import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPinOn = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "m28.879 27.605 10.704-10.704a2.27 2.27 0 0 0 2.88-.269.7.7 0 0 0 0-.99L32.357 5.537a.7.7 0 0 0-.99 0 2.27 2.27 0 0 0-.269 2.88L20.395 19.121a4.29 4.29 0 0 0-5.885.172.7.7 0 0 0 0 .99l5.353 5.353L9.739 35.758l-4.407 6.909 6.909-4.407 10.123-10.123 5.353 5.353a.7.7 0 0 0 .99 0 4.29 4.29 0 0 0 .172-5.885" }) }) })
});
export default SvgPinOn;
